import { RestaurantDetailsById } from "../../model/restaurants/byId";

export default function hasRegularTable(
  restaurantId: number,
  restaurantsById: RestaurantDetailsById,
  session: SessionType,
  people: number,
  isSingleMode: boolean,
) {
  const restaurant = restaurantsById[restaurantId];

  if (!restaurant) {
    return false;
  }

  if (!restaurant.offersRegularTable) {
    return false;
  }

  const availabilityConfig = restaurant.regularAvailabilityConfig?.[session];

  if (!availabilityConfig) {
    return false;
  }

  if (!availabilityConfig.active) {
    return false;
  }

  const { regularTableSessionTypes } = restaurant;

  const hasSession = regularTableSessionTypes?.includes(
    session.toLocaleLowerCase(),
  );

  if (!hasSession) {
    return false;
  }

  // always show the regular section in single mode (i.e. when selected on the map)
  if (isSingleMode) {
    return true;
  }

  const validPeople =
    people >= availabilityConfig.minGuests &&
    people <= availabilityConfig.maxGuests;

  return validPeople;
}
